// extracted by mini-css-extract-plugin
module.exports = {"pageRow":"PageRow_pageRow__3bE0-","text":"PageRow_text__10zrX","pageCounter":"PageRow_pageCounter__RiV1E","checkbox":"PageRow_checkbox__2wS8d"};